interface Props {
  stroke?: string;
}

const Cooldown = ({ stroke = '#3398DB' }: Props) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Sidebar"
        transform="translate(-24.000000, -440.000000)"
        stroke={stroke}
        fillRule="nonzero"
      >
        <path
          d="M36.5935452,449.66769 C37.3292022,449.403612 38.5566963,449.235895 39.7354629,449.890705 C41.7391289,451.003406 43.6225275,449.310355 43.3484127,447.435716 C43.1053229,445.77442 42.0793087,444.083011 40.7762596,443.403382 C38.8275261,442.38777 37.3521971,442.952972 36.2102955,444.192329 C35.4625935,445.004453 34.6805816,446.436712 34.6199916,447.798891 C34.5913392,448.440196 33.8467397,448.406433 33.6677073,447.906749 C33.4034475,447.171092 33.2357302,445.943415 33.8901747,444.765013 C35.0034239,442.760982 33.3101901,440.877401 31.435734,441.151698 C29.7742552,441.395153 28.083029,442.42062 27.4033995,443.724217 C26.3876052,445.672768 26.9528073,447.148097 28.1921639,448.289633 C29.0041058,449.037518 30.4370947,449.819895 31.7987262,449.880485 C32.4402133,449.908955 32.4064508,450.653554 31.9067661,450.832404 C31.1707442,451.096846 29.9430676,451.264746 28.7648485,450.609937 C26.7608174,449.496687 24.8772363,451.190104 25.1517161,453.064742 C25.3948059,454.726221 26.4206377,456.417447 27.7242342,457.096894 C29.6727853,458.112871 31.1481142,457.547486 32.2896509,456.30813 C33.0375353,455.49637 33.8197297,454.063564 33.8801372,452.70175 C33.9087897,452.06008 34.6532066,452.094208 34.8324215,452.59298 C35.0964988,453.329185 35.2643987,454.556679 34.6097717,455.735445 C33.4965225,457.738929 35.1897562,459.62251 37.0643948,459.34803 C38.7258736,459.10494 40.4170999,458.079839 41.0965469,456.776242 C42.1128886,454.827326 41.5473215,453.352545 40.307965,452.210278 C39.4962056,451.462941 38.0630341,450.680381 36.7015851,450.620157 C36.0600981,450.591504 36.0940431,449.847087 36.5935452,449.66769 Z"
          id="ic_cooldown"
        />
      </g>
    </g>
  </svg>
);

export default Cooldown;
